import makeStyles from '@mui/styles/makeStyles';
import clsx from 'clsx';
import InfoIcon from '@mui/icons-material/Info';
import React from 'react';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import DescriptionIcon from '@mui/icons-material/Description';
import PropTypes from 'prop-types';
import {AgyleLightBulbIcon} from '../icons/agyle';
import {startCase} from 'lodash';
import ErrorIcon from '@mui/icons-material/Error';

const useStyles = makeStyles((theme) => ({
    icon: {
        marginRight: 5,
        fontSize: 22,
        verticalAlign: 'top',
        '&.hint': {
            backgroundColor: theme.palette.background.paper,
            borderStyle: 'solid',
            borderColor: theme.palette.background.paper,
            borderRadius: '50%',
            fontSize: 40,
            padding: 5,
            color: theme.palette.background.paper,
        },
    },
    main: {
        borderRadius: 5,
        borderStyle: "solid",
        borderWidth: "3px",
        padding: 6,
        paddingRight: 12,
        margin: '10px 0px',
        fontWeight: 'bold',
        fontSize: 15,
        width: '100%',
        '&.info': {
            background: theme.palette.mode === 'dark' ? '#fff': '#3D3E40',
            color: theme.palette.mode === 'dark' ? '#3f3f3f': '#f5f5f5',
        },
        '&.warning': {
            background: '#FEE4B1',
            color: '#7F4501',
            borderColor: '#7F4501',
        },
        '&.warning-white': {
            backgroundColor: theme.palette.admissionForm.patientCardBackground,
            color: theme.palette.mode === 'light' ? '#3f3f3f': '#FFF',
        },
        '&.tip': {
            background: '#C0B6F2',
            color: '#172B4D',
        },
        '&.hint': {
            backgroundColor: theme.palette.background.default,
            color: '#FFF',
        },
        '&.holding-pen': {
            backgroundColor: "#F4C3C6",
            color: '#70191C',
            border: "1px solid #70191C"
        },
        '&.error': {
            backgroundColor: '#e85e5e',
            color: '#FFF',
        },
    },
    noMargin: {
        margin: 0,
    },
    border: {
        borderRadius: 8,
        // background: var(--dark-neutral-700, #3D3E40);
    },
    top: {
        padding: 7,
        borderBottom: '1px solid #626466',
    },
    bottom: {
        margin: '8px',
        marginRight: 0,
        display: 'flex',
        alignItems: 'center',
    }
}));

const InformationBox = (props) => {
    const classes = useStyles();
    let icon;

    switch (props.type) {
        case 'warning':
        case 'warning-white':
            icon = <WarningAmberIcon className={clsx(classes.icon, props.type)}/>;
            break;

        case 'tip':
            icon = <DescriptionIcon className={clsx(classes.icon, props.type)}/>;
            break;

        case 'hint':
            icon = <AgyleLightBulbIcon className={clsx(classes.icon, props.type)}/>;
            break;

        case 'error':
            icon = <ErrorIcon className={clsx(classes.icon, props.type)}/>;
            break;

        case 'info':
        default:
            icon = <InfoIcon className={clsx(classes.icon, props.type)}/>;
            break;
    }

    const getTitle = () => {
        if (props.label) return props.label
        if (props.type === "warning-white") return 'Warning';
        if (props.type === "info") return 'Information';
        if (props.type === "error") return 'Caution';
        return startCase(props.type);
    }

    return (
        <div className={clsx(classes.main, props.type, classes.border, props.noMargin && classes.noMargin)}>
            <div className={classes.bottom}>
                <span style={{marginRight: 5}}>{icon}</span>
                <span style={{display: "inline-block"}}>{props.children}</span>
            </div>
        </div>
    );
};

export default InformationBox;

InformationBox.propTypes = {
    type: PropTypes.oneOf(['info', 'warning', 'tip', 'hint', 'error', 'warning-white','holding-pen']).isRequired,
    noMargin: PropTypes.bool,
    label: PropTypes.string,
};

InformationBox.defaultProps = {
    noMargin: false,
};